import { Head } from '@/components/Head';
import { PublicCleanLayout } from '@/components/Layout';
import { SetupPublicPage } from '@/components/PublicPages/SetupPublicPage';

export const Setup = () => {
  window.history.replaceState(null, '', '/setup');

  return (
    <PublicCleanLayout>
      <Head />
      <SetupPublicPage />
    </PublicCleanLayout>
  );
};
